import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'

function CustomSnackbar({
  classes,
  message,
  action = [],
  autoHideDuration = 6000,
  ...props
}) {
  return (
    <Snackbar
      {...props}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      open={!!message}
      ContentProps={{
        'aria-describedby': 'message-id'
      }}
      action={[
        ...action,
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
      ]}
      message={
        <>
          <span id="message-id" style={{ marginRight: 16 }}>
            {message}
          </span>
          {message && <CircularProgress size={16} color="secondary" />}
        </>
      }
    />
  )
}

const styles = theme => ({
  close: {
    padding: theme.spacing(1 / 2)
  }
})

export default withStyles(styles)(CustomSnackbar)
